import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {MenuSet, MenuSetsService} from "../../../services/menu-sets.service";
import {Location} from '@angular/common';
import {NotificationsService} from "../../../services/notifications.service";

@Component({
  selector: 'menu-set-details',
  templateUrl: 'menu-set-details.component.html'
})

export class MenuSetDetailsComponent implements OnInit {
  menuSet: MenuSet;
  errors: any = {};
  editorSettings: any = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{'align': []}],
    ]
  };

  constructor(private route: ActivatedRoute, private menuSetsService: MenuSetsService, private location: Location, private notificationsService: NotificationsService) {
  }

  ngOnInit() {
    const menuSetId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.menuSetsService
      .getMenuSetDetails(menuSetId)
      .subscribe(data => this.menuSet = data);
  }

  submit() {
    this.menuSetsService
      .updateMenuSet(this.menuSet)
      .subscribe(
        _ => {
          this.notificationsService.show('Twoje menu zostało uaktualnione.')
          this.location.back()
        },
        response => this.errors = JSON.parse(response.error)
      )
  }

  cancel() {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/menu-set-details/menu-set-details.component.ts